import * as WebFont from "webfontloader";
import { webfontloaderConfig } from "types";

export function loadFontsWithWebFont() {
  WebFont.load(webfontloaderConfig);
}
